(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react', 'prop-types', 'react-motion', 'lodash/keys', 'lodash/map', './Item', './helpers'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'), require('react-motion'), require('lodash/keys'), require('lodash/map'), require('./Item'), require('./helpers'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes, global.reactMotion, global.keys, global.map, global.Item, global.helpers);
        global.Columns = mod.exports;
    }
})(this, function (exports, _react, _propTypes, _reactMotion, _keys, _map, _Item, _require) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _keys2 = _interopRequireDefault(_keys);

    var _map2 = _interopRequireDefault(_map);

    var _Item2 = _interopRequireDefault(_Item);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _slicedToArray = function () {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;

            try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);

                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally {
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally {
                    if (_d) throw _e;
                }
            }

            return _arr;
        }

        return function (arr, i) {
            if (Array.isArray(arr)) {
                return arr;
            } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            }
        };
    }();

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var clamp = _require.clamp,
        toColumns = _require.toColumns,
        calculateVisiblePositions = _require.calculateVisiblePositions,
        reinsert = _require.reinsert,
        getOrder = _require.getOrder,
        reorderData = _require.reorderData,
        springSetting = _require.springSetting,
        itemStyles = _require.itemStyles;

    var Columns = function (_Component) {
        _inherits(Columns, _Component);

        function Columns(props) {
            _classCallCheck(this, Columns);

            var _this = _possibleConstructorReturn(this, (Columns.__proto__ || Object.getPrototypeOf(Columns)).call(this, props));

            _initialiseProps.call(_this);

            var list = props.list,
                columnsCount = props.columns,
                getKey = props.getKey;


            var columns = toColumns(getKey ? (0, _map2.default)(list, getKey) : (0, _keys2.default)(list), columnsCount);
            _this.order = getOrder(columns);

            _this.state = {
                mouse: [0, 0],
                delta: [0, 0],
                lastPress: null,
                currentColumn: null,
                isPressed: false,
                isResizing: false,

                columns: columns
            };
            return _this;
        }

        _createClass(Columns, [{
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if (prevProps.list !== this.props.list) {
                    var _props = this.props,
                        list = _props.list,
                        getKey = _props.getKey,
                        columnsCount = _props.columns;

                    var columns = toColumns(getKey ? (0, _map2.default)(list, getKey) : (0, _keys2.default)(list), columnsCount);
                    this.order = getOrder(columns);
                    this.setState({ columns: columns });
                }
            }
        }, {
            key: 'componentWillMount',
            value: function componentWillMount() {
                this.resizeTimeout = null;
                this.layout = calculateVisiblePositions(this.state.columns, this.props.width, this.props.height);
            }
        }, {
            key: 'addEventListeners',
            value: function addEventListeners() {
                window.addEventListener('touchmove', this.handleTouchMove);
                window.addEventListener('mousemove', this.handleMouseMove);
                window.addEventListener('touchend', this.handleMouseUp);
                window.addEventListener('mouseup', this.handleMouseUp);
            }
        }, {
            key: 'removeEventListeners',
            value: function removeEventListeners() {
                window.removeEventListener('touchmove', this.handleTouchMove);
                window.removeEventListener('mousemove', this.handleMouseMove);
                window.removeEventListener('touchend', this.handleMouseUp);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        }, {
            key: 'render',
            value: function render() {
                var _this2 = this;

                var _state = this.state,
                    columns = _state.columns,
                    lastPress = _state.lastPress,
                    currentColumn = _state.currentColumn,
                    isPressed = _state.isPressed,
                    mouse = _state.mouse,
                    moved = _state.moved,
                    isResizing = _state.isResizing;
                var _props2 = this.props,
                    list = _props2.list,
                    params = _props2.params,
                    width = _props2.width,
                    height = _props2.height,
                    ItemTemplate = _props2.ItemTemplate;
                var order = this.order,
                    layout = this.layout;


                var maxHeight = height * columns.reduce(function (max, _ref) {
                    var length = _ref.length;
                    return length > max ? length : max;
                }, 0);
                var columnsStyle = {
                    position: 'relative',
                    height: maxHeight
                };

                return _react2.default.createElement(
                    'div',
                    { className: 'react-columns-items', ref: function ref(node) {
                            return _this2.items = node;
                        }, style: columnsStyle },
                    (0, _map2.default)(columns, function (column, colIndex) {
                        return (0, _map2.default)(column, function (row, rowIndex) {
                            var style = void 0,
                                x = void 0,
                                y = void 0,
                                visualPosition = columns[colIndex].indexOf(row),
                                index = order.indexOf(row),
                                isActive = row === lastPress && colIndex === currentColumn && isPressed && moved;

                            if (isActive) {
                                var _mouse = _slicedToArray(mouse, 2);

                                x = _mouse[0];
                                y = _mouse[1];

                                style = {
                                    translateX: x,
                                    translateY: y
                                };
                            } else if (isResizing) {
                                var _layout$colIndex$visu = _slicedToArray(layout[colIndex][visualPosition], 2);

                                x = _layout$colIndex$visu[0];
                                y = _layout$colIndex$visu[1];

                                style = {
                                    translateX: x,
                                    translateY: y
                                };
                            } else {
                                var _layout$colIndex$visu2 = _slicedToArray(layout[colIndex][visualPosition], 2);

                                x = _layout$colIndex$visu2[0];
                                y = _layout$colIndex$visu2[1];

                                style = {
                                    translateX: (0, _reactMotion.spring)(x, springSetting),
                                    translateY: (0, _reactMotion.spring)(y, springSetting)
                                };
                            }

                            return _react2.default.createElement(
                                _reactMotion.Motion,
                                { key: row, style: style },
                                function (_ref2) {
                                    var translateX = _ref2.translateX,
                                        translateY = _ref2.translateY;
                                    return _react2.default.createElement(
                                        'div',
                                        {
                                            onMouseDown: _this2.handleMouseDown.bind(null, row, colIndex, [x, y]),
                                            onTouchStart: _this2.handleTouchStart.bind(null, row, colIndex, [x, y]),
                                            className: isActive ? 'react-columns-item react-columns-item-active' : 'react-columns-item',
                                            style: Object.assign({}, itemStyles, {
                                                width: width,
                                                height: height,
                                                WebkitTransform: 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0))',
                                                transform: 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0)',
                                                zIndex: row === lastPress && colIndex === currentColumn ? 99 : visualPosition
                                            })
                                        },
                                        _react2.default.createElement(_Item2.default, {
                                            ItemTemplate: ItemTemplate,
                                            params: params,
                                            item: list[index],
                                            index: Number(index)
                                        })
                                    );
                                }
                            );
                        });
                    })
                );
            }
        }]);

        return Columns;
    }(_react.Component);

    Columns.propTypes = {
        list: _propTypes2.default.array.isRequired,
        getKey: _propTypes2.default.func,
        params: _propTypes2.default.any,
        columns: _propTypes2.default.number,
        fixed: _propTypes2.default.bool,
        ItemTemplate: _propTypes2.default.func.isRequired,
        onChange: _propTypes2.default.func
    };

    var _initialiseProps = function _initialiseProps() {
        var _this3 = this;

        this.handleTouchStart = function (key, currentColumn, pressLocation, e) {
            _this3.handleMouseDown(key, currentColumn, pressLocation, e.touches[0]);
        };

        this.handleTouchMove = function (e) {
            e.preventDefault();
            _this3.handleMouseMove(e.touches[0]);
        };

        this.handleMouseMove = function (_ref3) {
            var pageX = _ref3.pageX,
                pageY = _ref3.pageY;
            var _props3 = _this3.props,
                width = _props3.width,
                height = _props3.height,
                fixed = _props3.fixed,
                columnsNumber = _props3.columns;

            var _state2 = _this3.state,
                columns = _state2.columns,
                lastPress = _state2.lastPress,
                colFrom = _state2.currentColumn,
                isPressed = _state2.isPressed,
                _state2$delta = _slicedToArray(_state2.delta, 2),
                dx = _state2$delta[0],
                dy = _state2$delta[1];

            var newColumns = columns;

            if (isPressed) {
                var mouse = [pageX - dx, pageY - dy];
                var colTo = clamp(Math.floor((mouse[0] + width / 2) / width), 0, 2);
                var rowTo = clamp(Math.floor((mouse[1] + height / 2) / height), 0, 100);
                var rowFrom = columns[colFrom].indexOf(lastPress);

                var couldReinsert = rowFrom !== -1 && columns[colTo];

                if (couldReinsert) {
                    newColumns = reinsert(columns, colFrom, rowFrom, colTo, rowTo, columnsNumber, fixed);
                }

                _this3.layout = calculateVisiblePositions(newColumns, width, height);

                _this3.setState({
                    moved: true,
                    mouse: mouse,
                    columns: newColumns,
                    currentColumn: couldReinsert ? colTo : colFrom
                });
            }
        };

        this.handleMouseDown = function (key, currentColumn, _ref4, _ref5) {
            var _ref6 = _slicedToArray(_ref4, 2),
                pressX = _ref6[0],
                pressY = _ref6[1];

            var pageX = _ref5.pageX,
                pageY = _ref5.pageY,
                button = _ref5.button;

            if (button) {
                return;
            }

            _this3.addEventListeners();

            _this3.setState({
                lastPress: key,
                currentColumn: currentColumn,
                isPressed: true,
                delta: [pageX - pressX, pageY - pressY],
                mouse: [pressX, pressY]
            });
        };

        this.handleMouseUp = function () {
            var _props4 = _this3.props,
                onChange = _props4.onChange,
                list = _props4.list,
                getKey = _props4.getKey;
            var columns = _this3.state.columns;


            _this3.order = getOrder(columns);
            if (onChange) {
                onChange(reorderData(list, columns, getKey));
            }

            _this3.setState({
                moved: false,
                isPressed: false,
                delta: [0, 0]
            });

            _this3.removeEventListeners();
        };
    };

    exports.default = Columns;
});